import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "src/store";

export const useGetContactPersonDetail = () => {
  const selector = useCallback(
    (state: RootState) => ({
      contactPersonDetails: state.generalReducer.applicationReducer.contactPersonDetails
    }),
    []
  );

  const { contactPersonDetails } = useSelector(selector, (prev, cur) => prev.contactPersonDetails === cur.contactPersonDetails);

  const getContactPersonDetail = useMemo(() => (contactPersonDetails.loading === "has-loaded" ? contactPersonDetails.data : undefined), [contactPersonDetails]);
  return { contactPersonDetail: getContactPersonDetail };
};
